import { all } from 'redux-saga/effects';
import {
  initPaymentMethodsSaga,
  allPaymentMethodsSaga,
  addPaymentMethodSaga,
  deletePaymentMethodSaga,
  saveCoverageSaga,
  calculateSaga,
  getPaymentMethodsFilterSaga,
  getInstallmentsCountryInfosSaga,
  enableInstallmentsCountrySaga,
  disableInstallmentsCountrySaga,
} from './payment-methods/sagas';
import { initLoginSaga, sendLoginSaga, sendTwoFactorVerifySaga, sendLogoutSaga } from './auth/sagas';
import { sendSignUpSaga } from './sign-up/sagas';
import {
  initDashboardSaga,
  getUserMeSaga,
  tokenCheckedSaga,
  getMerchantMeSaga,
  initDashboardFinishSaga,
} from './dashboard/sagas';
import {
  getDocumentTypesForKYCSaga,
  sendKYCSaga,
  deleteLogoSaga,
  uploadLogoSaga,
  getKycLevelsSaga,
  getIndustriesSaga,
  getMissingDocumentsSaga,
  getKycDocumentsSaga,
  uploadKycDocumentsSaga,
  startKyc2ValidationSaga,
} from './company-information/sagas';
import {
  getTransactionsSaga,
  getTransactionDetailSaga,
  getPaymentMethodsForTransSaga,
  exportTransactionsSaga,
  getPreChargebackFormSaga,
  getAffiliationsInfoSaga,
  getTransactionsStatementDataSaga,
} from './transactions/sagas';
import { getBalancesSaga } from './home/sagas';
import { sendEmailValidationSaga, sendConfirmEmailSaga } from './email-validation/sagas';
import {
  getSettlementsSaga,
  getBeneficiariesSaga,
  requestSettlementSaga,
  exportSettlementDetailSaga,
} from './settlements/sagas';
import { getCheckoutThemesSaga, postCreateCheckoutThemeSaga, toggleCheckoutThemeSaga, getCheckoutPhoneRequiredSaga, updateCheckoutPhoneRequiredSaga } from './checkout-theme/sagas';
import {
  getCurrenciesSaga,
  getDocumentTypesForPaymentLinkSaga,
  createPaymentLinkSaga,
  getExistingClientsSaga,
  getCreatedOneTimePaymentLinksSaga,
  getCreatedRecurringPaymentLinksSaga,
  changeStatusRecurringPaymentLinkSaga,
} from './payment-link/sagas';
import {
  getCurrenciesVirtualPosSaga,
  getDocumentTypesVirtualPosSaga,
  createPaymentSaga,
  confirmPaymentSaga,
} from './virtual-pos/sagas';
import { getIntegrationKeysSaga, getCurrenciesPISaga, setShopifyTestModeSaga } from './payment-integration/sagas';
import {
  getRefundsSaga,
  getBanksSaga,
  sendRequestRefundSaga,
  getPaymentMethodsForRefundsSaga,
  getRefundDetailSaga,
  exportRefundDetailSaga,
  exportRefundsSaga,
} from './refunds/sagas';
import {
  getPayoutsSaga,
  getBanksSaga as getPayoutsBanksSaga,
  sendRequestPayoutSaga,
  getPayoutDetailSaga,
  exportPayoutDetailSaga,
  exportPayoutsSaga,
  getRequiredFieldsSaga,
  getPayoutFeeSaga,
  validatePartialPayoutSaga,
  confirmPayoutSaga,
  verifyOtpConfiguredSaga,
  getPayoutCountryConfigurationsSaga,
  getPayoutCurrenciesSaga,
} from './payouts/sagas';
import {
  reportsGetTransactionsByPaymentMethodSaga,
  reportsGetTransactionsByPaymentSolutionSaga,
  reportsGetPaymentVolumeSaga,
  reportsGetTransactionsByCountrySaga,
  reportsTransactionsSummarySaga,
} from './reports/sagas';
import { sendPasswordResetSaga, confirmPasswordResetSaga } from './password-reset/sagas';
import { invitationPasswordSaga } from './invitation-password/sagas';
import {
  savePersonalInfoSaga,
  changePasswordSaga,
  setupTwoFactorSaga,
  confirmTwoFactorSaga,
  disableTwoFactorSaga,
} from './profile/sagas';
import { deleteClientSaga, exportClientsSaga, getClientsSaga, getClientsSummarySaga } from './clients/sagas';
import {
  getBankAccountsSaga,
  getBanksByCountrySaga,
  addBankAccountSaga,
  deleteBankAccountSaga,
} from './bank-accounts/sagas';
import { jumioRefreshStatusSaga, jumioStartSaga } from './jumio/sagas';
import {
  deactivatePlanSaga,
  deactivateSubscriptionSaga,
  getPlansSaga,
  getSubscriptionsSaga,
  createUpdatePlanSaga,
} from './subscriptions/sagas';
import {
  getChargebacksSaga,
  getChargebackDetailSaga,
  exportChargebacksSaga,
  sendChargebackDocumentSaga,
} from './chargebacks/sagas';
import {
  validateMerchantCollaboratorSaga,
  getSplitPaymentsSaga,
  postCreateSplitPaymentSaga,
  performCollaborationActionSaga,
  cancelCollaborationSaga,
  exportSplitsSaga,
} from './split-payments/sagas';

import { getMerchantMarketingConfigSaga, updateMerchantMarketingConfigSaga } from './marketing/sagas';
import { getMerchantUsersSaga, deleteMerchantUserSaga, restoreMerchantUserSaga, swapOwnerRoleSaga, inviteUserSaga, resendInviteSaga } from './user-management/sagas';

export function delay(ms: number) {
  return new Promise(resolve => setTimeout(() => resolve(true), ms));
}

export default function* rootSaga() {
  yield all([
    initLoginSaga(),
    sendLoginSaga(),
    sendTwoFactorVerifySaga(),
    sendSignUpSaga(),
    sendLogoutSaga(),
    initDashboardSaga(),
    getUserMeSaga(),
    tokenCheckedSaga(),
    getMerchantMeSaga(),
    initDashboardFinishSaga(),
    initPaymentMethodsSaga(),
    getDocumentTypesForKYCSaga(),
    sendKYCSaga(),
    deleteLogoSaga(),
    uploadLogoSaga(),
    getKycLevelsSaga(),
    allPaymentMethodsSaga(),
    addPaymentMethodSaga(),
    deletePaymentMethodSaga(),
    saveCoverageSaga(),
    getTransactionsSaga(),
    getTransactionDetailSaga(),
    getPreChargebackFormSaga(),
    getTransactionsStatementDataSaga(),
    getAffiliationsInfoSaga(),
    getPaymentMethodsForTransSaga(),
    exportTransactionsSaga(),
    getBalancesSaga(),
    sendEmailValidationSaga(),
    sendConfirmEmailSaga(),
    getSettlementsSaga(),
    getBeneficiariesSaga(),
    requestSettlementSaga(),
    getCurrenciesSaga(),
    getDocumentTypesForPaymentLinkSaga(),
    createPaymentLinkSaga(),
    getExistingClientsSaga(),
    getCreatedOneTimePaymentLinksSaga(),
    getCreatedRecurringPaymentLinksSaga(),
    changeStatusRecurringPaymentLinkSaga(),
    getIntegrationKeysSaga(),
    reportsTransactionsSummarySaga(),
    reportsGetPaymentVolumeSaga(),
    reportsGetTransactionsByCountrySaga(),
    reportsGetTransactionsByPaymentSolutionSaga(),
    reportsGetTransactionsByPaymentMethodSaga(),
    getRefundsSaga(),
    getRefundDetailSaga(),
    exportRefundDetailSaga(),
    exportRefundsSaga(),
    getBanksSaga(),
    sendRequestRefundSaga(),
    getPaymentMethodsForRefundsSaga(),
    getPayoutsSaga(),
    getPayoutDetailSaga(),
    exportPayoutDetailSaga(),
    exportPayoutsSaga(),
    getPayoutsBanksSaga(),
    sendRequestPayoutSaga(),
    getRequiredFieldsSaga(),
    getPayoutFeeSaga(),
    validatePartialPayoutSaga(),
    confirmPayoutSaga(),
    sendPasswordResetSaga(),
    confirmPasswordResetSaga(),
    getCurrenciesPISaga(),
    savePersonalInfoSaga(),
    changePasswordSaga(),
    setupTwoFactorSaga(),
    confirmTwoFactorSaga(),
    disableTwoFactorSaga(),
    getClientsSaga(),
    getClientsSummarySaga(),
    exportClientsSaga(),
    deleteClientSaga(),
    getBankAccountsSaga(),
    getBanksByCountrySaga(),
    addBankAccountSaga(),
    deleteBankAccountSaga(),
    getCurrenciesVirtualPosSaga(),
    getDocumentTypesVirtualPosSaga(),
    createPaymentSaga(),
    confirmPaymentSaga(),
    getIndustriesSaga(),
    getMissingDocumentsSaga(),
    startKyc2ValidationSaga(),
    setShopifyTestModeSaga(),
    jumioStartSaga(),
    jumioRefreshStatusSaga(),
    getSubscriptionsSaga(),
    getPlansSaga(),
    createUpdatePlanSaga(),
    deactivateSubscriptionSaga(),
    deactivatePlanSaga(),
    getChargebacksSaga(),
    getChargebackDetailSaga(),
    exportChargebacksSaga(),
    sendChargebackDocumentSaga(),
    getCheckoutThemesSaga(),
    postCreateCheckoutThemeSaga(),
    toggleCheckoutThemeSaga(),
    getCheckoutPhoneRequiredSaga(),
    updateCheckoutPhoneRequiredSaga(),
    calculateSaga(),
    getPaymentMethodsFilterSaga(),
    getInstallmentsCountryInfosSaga(),
    enableInstallmentsCountrySaga(),
    disableInstallmentsCountrySaga(),
    getKycDocumentsSaga(),
    uploadKycDocumentsSaga(),
    validateMerchantCollaboratorSaga(),
    getSplitPaymentsSaga(),
    postCreateSplitPaymentSaga(),
    performCollaborationActionSaga(),
    cancelCollaborationSaga(),
    exportSplitsSaga(),
    getMerchantMarketingConfigSaga(),
    updateMerchantMarketingConfigSaga(),
    getMerchantUsersSaga(),
    deleteMerchantUserSaga(),
    restoreMerchantUserSaga(),
    swapOwnerRoleSaga(),
    inviteUserSaga(),
    resendInviteSaga(),
    invitationPasswordSaga(),
    exportSettlementDetailSaga(),
    verifyOtpConfiguredSaga(),
    getPayoutCountryConfigurationsSaga(),
    getPayoutCurrenciesSaga(),
  ]);
}
